import { render, staticRenderFns } from "./ListLeads.vue?vue&type=template&id=1dc5ff5a&"
import script from "./ListLeads.vue?vue&type=script&lang=js&"
export * from "./ListLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports